import commonMessage from "../constant/commonMessage"
import { toastMessage } from "./toastMessageHelper";

const {INVALID_BASE64,INVALID_BASE64_FORMAT,MIME_NOT_FOUND} = commonMessage

export const base64ToFile = (base64Url, fileName) => {
    if (!base64Url || typeof base64Url !== "string") {
      toastMessage(INVALID_BASE64,"warning","base64File")
    }
  
    const [metaPart, dataPart] = base64Url.split(',');
    if (!metaPart || !dataPart) {
        toastMessage(INVALID_BASE64_FORMAT,"warning","base64File")
    }
  
    const mimeMatch = metaPart.match(/:(.*?);/);
    if (!mimeMatch) {
        toastMessage(MIME_NOT_FOUND,"warning","base64File")
    }
  
    const mimeType = mimeMatch[1];
    const binaryData = atob(dataPart);
    const byteLength = binaryData.length;
    const uint8Array = new Uint8Array(byteLength);
  
    for (let i = 0; i < byteLength; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }
  
    return new File([uint8Array], fileName, { type: mimeType });
  };
  